module.exports = __webpack_public_path__ + "static/friends-sketch@2x-1e6d40b62879309740524aeb29c2b2bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/pop/sketches/friends-sketch@2x.png
// module id = 928
// module chunks = 173944852332284 271422636699454